import React from 'react';
import './LongestResponse.css';
import logComponent from '../../common/logComponent';
import LongestResponse from './LongestResponse';
import { CardLongestResponseProvider } from '../../contexts/CardLongestResponseContext';
 
export default function LongestResponseCard({ moduleDescription }) {
  if (logComponent('LongestResponseCard')) { console.debug('LongestResponseCard rendered'); }


  return (
    <CardLongestResponseProvider>
      <LongestResponse moduleDescription={moduleDescription} />
    </CardLongestResponseProvider>
  );
}